import { useEffect, useState } from "react";
import "../css/dashboard.css";
import "../css/client.css";
import { Box, Button, Menu, MenuItem, Modal } from "@mui/material";
import TopTitleBannerMobile from "../component/TopTitleBannerMobile";
import AddClientMobile from "../component/forms/AddClientMobile";
import { useAuth } from "../contexts/AuthContext";
import {
  collection,
  documentId,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { roles } from "../firebase.collection";
import AddQuickNoteWithClientsMobile from "../component/Notes/AddQuickNoteWithClientsMobile";
import { db } from "../firebase";
import { format } from "date-fns";
import MetricsWidgetV2Mobile from "../component/MetricsWidgetV2Mobile";
import NotesContainerMobile from "../component/Notes/NotesContainerMobile";
import EndOfShiftNoteContainerMobile from "../component/Notes/EndOfShiftNoteContainerMobile";
import FamilyNoteContainerMobile from "../component/Notes/FamilyNoteContainerMobile";
import MedicalNoteContainerMobile from "../component/Notes/MedicalNoteContainerMobile";
import HandoverNotesContainerGlobalMobile from "../component/Notes/HandoverNotesContainerGlobalMobile";
import GroupNotesContainerGlobalMobile from "../component/Notes/GroupNotesContainerGlobalMobile";
import NotesAddModal from "../component/modals/NotesAddModal";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

export default function HomepageContentMobile() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [notes, setNotes] = useState([]);
  const [, setReadCount] = useState(0);
  const userIdState = currentUser ? currentUser.uid : "";
  const [userRole, setUserRole] = useState("");
  const [, setNoteTypes] = useState([]);
  const [selectedClientName] = useState("");
  const [selectedNoteType] = useState([]);
  const [clients, setClients] = useState([]);
  const [clientsIncoming, setClientsIncoming] = useState([]);
  const [nextDischargeClient, setNextDischargeClient] = useState(null);
  const [, setIsLoading] = useState(true);
  const [, setIsLoadingIncoming] = useState(true);
  const [anchorElNoteType, setAnchorElNoteType] = useState(null);
  const [, setFirestoreReadCount] = useState(0);
  const openNoteTypeMenu = Boolean(anchorElNoteType);
  const [openAddModal2, setOpenAddModal2] = useState(false);

  const [currentNoteType, setCurrentNoteType] = useState("");

  const formatNoteType = (noteType) => {
    return noteType
      .replace(/([A-Z])/g, " $1") // Ajouter un espace avant chaque lettre majuscule
      .replace(/^./, (str) => str.toUpperCase()); // Mettre la première lettre en majuscule
  };

  const handleSelectNoteType = (noteType) => {
    setCurrentNoteType(noteType);
    setOpenAddModal2(true);
    handleCloseNoteTypeMenu();
  };

  const handleOpenNoteTypeMenu = (event) => {
    setAnchorElNoteType(event.currentTarget);
  };

  const handleCloseNoteTypeMenu = () => {
    setAnchorElNoteType(null);
  };
  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    height: 600,
    backgroundColor: "white",
    boxShadow: 24,
    borderRadius: 10,
  };

  const handleClientClick = (clientId) => {
    window.open(`/client/${clientId}`, "_blank");
  };

  useEffect(() => {
    setIsLoading(true);

    const queryRef = query(
      collection(db, "clients"),
      where("clientStatus", "==", "In House")
    );

    const unsubscribe = onSnapshot(
      queryRef,
      async (snapshot) => {
        const clientsData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setClients(clientsData);
        setIsLoading(false);
        incrementFirestoreReadCount(snapshot.docs.length);
      },
      (error) => {
        console.error("Failed to fetch In House clients:", error);
        setIsLoading(false);
      }
    );

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  useEffect(() => {
    setIsLoadingIncoming(true);

    const clientQuery = query(
      collection(db, "clients"),
      where("clientStatus", "==", "Incoming")
    );

    const unsubscribe = onSnapshot(
      clientQuery,
      async (snapshot) => {
        const clientsIncomingData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setClientsIncoming(clientsIncomingData);
        setIsLoadingIncoming(false);
        incrementFirestoreReadCount(snapshot.docs.length);
      },
      (error) => {
        console.error("Failed to fetch Incoming clients:", error);
        setIsLoadingIncoming(false);
      }
    );

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  const fixedNoteTypes = [
    "aftercareNote",
    "medicalNote",
    "quickNote",
    "familyNote",
    "supportStaffNote",
    "therapyNote",
    "handoverNote",
    "groupNote",
    "endOfShift",
  ];

  useEffect(() => {
    if (clients.length > 0) {
      const now = new Date();
      const closestClient = clients.reduce((closest, client) => {
        const dischargeDate = new Date(
          client.projectedResidentialDischargeDate?.seconds * 1000
        );

        if (isNaN(dischargeDate.getTime()) || dischargeDate <= now) {
          return closest; // Ignore invalid or past dates
        }
        if (
          closest === null ||
          dischargeDate <
            new Date(closest.projectedResidentialDischargeDate?.seconds * 1000)
        ) {
          return client;
        }
        return closest;
      }, null);

      setNextDischargeClient(closestClient);
    }
  }, [clients]);

  function formatDate2(date) {
    if (!date || isNaN(date.getTime())) {
      console.log("Invalid date provided to formatDate");
      return "Invalid date"; // Retourner une chaîne indiquant que la date est invalide
    }
    try {
      return format(date, "dd MMMM yyyy"); // Format correct avec date-fns
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Formatting error";
    }
  }

  const incrementFirestoreReadCount = (incrementBy = 1) => {
    setFirestoreReadCount((prevCount) => prevCount + incrementBy);
  };

  useEffect(() => {
    const notesRef = collection(db, "notes");
    const q = query(notesRef, orderBy("effectiveDateTime", "desc"), limit(25));

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const notesData = [];
      const types = new Set();
      querySnapshot.forEach((doc) => {
        const noteData = { id: doc.id, ...doc.data() };
        notesData.push(noteData);
        types.add(noteData.noteType);
      });
      setNotes(notesData);
      setNoteTypes(Array.from(types));
      setReadCount((prevCount) => prevCount + querySnapshot.size);
      incrementFirestoreReadCount(querySnapshot.size);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  const filteredNotes = userRole
    ? notes
        .filter((note) => {
          const matchesType = selectedNoteType.length
            ? selectedNoteType.includes(note.noteType)
            : true;

          const matchesClient = selectedClientName
            ? `${note.clientFirstName} ${note.clientLastName}`.toLowerCase() ===
              selectedClientName.toLowerCase()
            : true;

          // ✅ Vérifie si l'utilisateur peut voir cette note
          const isVisibleToUser =
            note.noteType !== "therapyNote" || // Toutes les notes sauf therapyNote sont visibles
            userRole === "Super Admin" ||
            userRole === "Clinical Director" ||
            (userRole === "Therapist" &&
              note.doneBy === currentUser.displayName); // Les therapists voient uniquement leurs propres therapyNotes

          // 🔍 LOGGING DES TESTS
          console.log("🔍 Vérification de la note :", note.id);
          console.log("   - 📝 Type :", note.noteType);
          console.log("   - 👤 Créateur de la note (doneBy) :", note.doneBy);
          console.log("   - 🔐 Utilisateur actuel :", currentUser.displayName);
          console.log("   - 🎭 Rôle de l'utilisateur :", userRole);
          console.log("   - ✅ matchesType :", matchesType);
          console.log("   - ✅ matchesClient :", matchesClient);
          console.log(
            "   - 🔍 Est visible pour l'utilisateur ?",
            isVisibleToUser
          );

          return matchesType && matchesClient && isVisibleToUser;
        })
        .sort((a, b) => {
          return b.effectiveDateTime.toDate() - a.effectiveDateTime.toDate();
        }) // Trie du plus récent au plus ancien
    : []; // 🔴 Si `userRole` est vide, ne retourne rien encore.

  const styleModalQuickNote = {
    ...styleModalGeneral, // Vous pouvez réutiliser le style de la modal générale
  };

  const [openAddClient, setOpenAddClient] = useState(false);
  const [openAddQuickNote, setOpenAddQuickNote] = useState(false);
  const isPhilippinesClient = (client) =>
    client.rehabId === "miracles_asia_philippines" ||
    client.rehabCountry === "Philippines";

  const activePHClients = clients.filter(isPhilippinesClient);
  const inHouseTHClients = clients.filter((client) => !isPhilippinesClient(client));

  const handleOpenAddClient = () => setOpenAddClient(true);
  const handleCloseAddClient = () => setOpenAddClient(false);

  const handleCloseAddQuickNote = () => setOpenAddQuickNote(false);

  function queryRole() {
    const roleQuery = query(roles, where(documentId(), "==", userIdState));

    onSnapshot(roleQuery, (querySnapshot) => {
      if (!querySnapshot.empty) {
        const role = querySnapshot.docs[0].data().role;
        console.log("🎭 Rôle récupéré :", role); // LOG du rôle
        setUserRole(role);
      } else {
        console.log("❌ Aucun rôle trouvé pour cet utilisateur.");
        setUserRole(null);
      }
    });
  }

  const formatDate = (date, options) => {
    return date
      ? new Intl.DateTimeFormat("en-EN", options).format(date.toDate())
      : "";
  };

  // useEffect(() => {
  //   if (currentUser) {
  //     queryRole();
  //   } else {
  //     console.log("No user id");
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentUser]);

  useEffect(() => {
    if (currentUser) {
      queryRole();
    } else {
      console.log("❌ Aucun utilisateur connecté.");
    }
  }, [currentUser]);

  return (
    <div className="right-container-mobile">
      <NotesAddModal
        open={openAddModal2}
        onClose={() => setOpenAddModal2(false)}
        // onClose={handleCloseAddNoteModal}
        noteType={currentNoteType}
        // handleSave={handleSaveNote}
        isMobile={true}
      />
      <Modal
        open={openAddClient}
        onClose={handleCloseAddClient}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalGeneral}>
          <AddClientMobile closemodal={handleCloseAddClient} />
        </Box>
      </Modal>
      <Modal
        open={openAddQuickNote}
        onClose={handleCloseAddQuickNote}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleModalQuickNote}>
          <AddQuickNoteWithClientsMobile closemodal={handleCloseAddQuickNote} />
        </Box>
      </Modal>
      <TopTitleBannerMobile title={"Dashboard"} />

      <div className="top-component-list-clients-mobile">
        <div className="dashboard-summary-toolbar-mobile">
          <div
            className="dashboard-summary-card-action"
            onClick={() => navigate("/clients")}
          >
            <MetricsWidgetV2Mobile
              title="# Inhouse TH"
              value={inHouseTHClients.length.toString()}
              title2="Clients"
              backgroundColor="#425e8d"
              textColor="white"
            />
          </div>
          <div
            className="dashboard-summary-card-action"
            onClick={() => navigate("/clients?rehab=ph&tab=inhouse")}
          >
            <MetricsWidgetV2Mobile
              title="Active PH"
              value={activePHClients.length.toString()}
              title2="Clients"
              backgroundColor="#16865d"
              textColor="white"
            />
          </div>
          <div>
            <MetricsWidgetV2Mobile
              title="Next Departure "
              value={
                nextDischargeClient ? (
                  <span
                    className="dashboard-summary-link"
                    onClick={() => handleClientClick(nextDischargeClient.id)}
                  >
                    {`${nextDischargeClient.firstName} ${nextDischargeClient.lastName}`}
                  </span>
                ) : (
                  "No discharges"
                )
              }
              title2={
                nextDischargeClient
                  ? formatDate2(
                      new Date(
                        nextDischargeClient.projectedResidentialDischargeDate
                          ?.seconds * 1000
                      )
                    )
                  : "---"
              }
              backgroundColor="#425e8d"
              textColor="white"
            />
          </div>

          <div>
            <MetricsWidgetV2Mobile
              title="Next Incoming "
              value={
                clientsIncoming.length > 0 ? (
                  <span
                    className="dashboard-summary-link"
                    onClick={() => handleClientClick(clientsIncoming[0].id)}
                  >
                    {`${clientsIncoming[0].firstName} ${clientsIncoming[0].lastName}`}
                  </span>
                ) : (
                  "No upcoming clients"
                )
              }
              title2={
                clientsIncoming.length > 0
                  ? formatDate2(
                      new Date(clientsIncoming[0].eta?.seconds * 1000)
                    )
                  : "N/A"
              }
              backgroundColor="#425e8d"
              textColor="white"
            />{" "}
          </div>
        </div>

        {/* <div style={{ width: "100%", paddingLeft: "20px" }}>
          <SearchBarMobile />
        </div> */}
        <div className="dashboard-summary-actions-mobile">
          {(userRole === "Super Admin" || userRole === "Admission staff") && (
            // userRole === "Support Staff" ||
            // userRole === "Clinical Director" ||
            // userRole === "Admin" ||
            // userRole === "Medical Staff" ||
            // userRole === "Therapist"
            <>
              <Button
                className="dashboard-summary-action-button"
                onClick={handleOpenAddClient}
                variant="outlined"
                startIcon={<Add />}
              >
                Add Client
              </Button>
              <Button
                className="dashboard-summary-action-button dashboard-summary-action-button-secondary"
                onClick={handleOpenNoteTypeMenu}
                startIcon={<Add />}
                // onClick={handleOpenAddQuickNote}
                variant="outlined"
              >
                Add Note
              </Button>
              <Menu
                anchorEl={anchorElNoteType}
                open={openNoteTypeMenu}
                onClose={handleCloseNoteTypeMenu}
              >
                {/* {noteTypes.map((noteType) => ( */}
                {fixedNoteTypes.map((noteType) => (
                  <MenuItem
                    key={noteType}
                    onClick={() => handleSelectNoteType(noteType)}
                  >
                    {formatNoteType(noteType)}
                  </MenuItem>
                ))}
              </Menu>
            </>
          )}
        </div>
        <div
          style={{
            fontSize: "18px",
            fontWeight: "600",
            marginBottom: "15px",
            marginTop: "25px",
            paddingLeft: "15px",
          }}
        >
          Recent Clients Notes ({filteredNotes.length})
        </div>

        <div
          style={{
            width: "100%",
            height: "auto",
            display: "flex",
            flexDirection: "row",
            paddingLeft: "15px",
            paddingRight: "15px",
          }}
        >
          <div
            style={{
              width: "100%",
              // maxHeight: "500px",
              overflowY: "auto",
            }}
          >
            {filteredNotes.map((note, index) => {
              const dateOptions = {
                day: "numeric",
                month: "short",
                year: "numeric",
              };

              const dateOptions2 = {
                day: "numeric",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
              };

              const timeOptions = {
                hour: "2-digit",
                minute: "2-digit",
              };

              const formattedTimestamp = note.createdAt
                ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                    note.createdAt.toDate()
                  )
                : "";

              const formattedLastModification = note.updateAt
                ? new Intl.DateTimeFormat("en-EN", dateOptions2).format(
                    note.updateAt.toDate()
                  )
                : "";

              const formattedDate = note.effectiveDateTime
                ? new Intl.DateTimeFormat("en-EN", dateOptions).format(
                    note.effectiveDateTime.toDate()
                  )
                : "";

              const formattedTime = note.effectiveDateTime
                ? new Intl.DateTimeFormat("en-EN", timeOptions).format(
                    note.effectiveDateTime.toDate()
                  )
                : "";

              const noteDate = formatDate(note.shiftStart, dateOptions);
              const noteTime = formatDate(note.shiftStart, timeOptions); // Assurez-vous que c'est bien le champ que vous voulez utiliser
              const noteDateEnd = formatDate(note.shiftEnd, dateOptions);
              const noteDateEndTime = formatDate(note.shiftEnd, timeOptions);

              switch (note.noteType) {
                case "quickNote":
                case "nonTherapyNote":
                case "therapyNote":
                case "supportStaffNote":
                case "aftercareNote":
                  return (
                    <NotesContainerMobile
                      key={note.id}
                      noteContent={note.noteContent}
                      effectiveDate={note.effectiveDateTime}
                      noteDate={formattedDate}
                      noteTime={formattedTime}
                      doneBy={note.doneBy}
                      timeStamp={formattedTimestamp}
                      lastModification={formattedLastModification}
                      clientPic={note.clientProfilePicture}
                      clientFirstName={note.clientFirstName}
                      clientLastName={note.clientLastName}
                      noteId={note.id}
                      {...note}
                    />
                  );

                case "endOfShift":
                  return (
                    <EndOfShiftNoteContainerMobile
                      key={note.id}
                      noteContent={note.noteContent}
                      shiftStartRaw={note.shiftStart}
                      shiftEndRaw={note.shiftEnd}
                      shiftStart={noteDate}
                      shiftEnd={noteDateEnd}
                      staff={note.staff}
                      doneBy={note.doneBy}
                      noteId={note.id}
                      noteType={note.noteType}
                      noteDate={noteDate} // Date formatée
                      noteTime={noteTime} // Heure formatée
                      noteDateEndTime={noteDateEndTime}
                    />
                  );

                case "familyNote":
                  return (
                    <FamilyNoteContainerMobile
                      key={note.id}
                      noteContent={note.noteContent}
                      effectiveDate={note.effectiveDateTime}
                      noteDate={formattedDate}
                      noteTime={formattedTime}
                      doneBy={note.doneBy}
                      timeStamp={formattedTimestamp}
                      lastModification={formattedLastModification}
                      clientPic={note.clientProfilePicture}
                      clientFirstName={note.clientFirstName}
                      clientLastName={note.clientLastName}
                      noteId={note.id}
                      relationship={note.relationShipFamilyNote}
                      fileUrls={note.fileUrls}
                      {...note}
                    />
                  );

                case "medicalNote":
                  return (
                    <MedicalNoteContainerMobile
                      key={note.id}
                      noteContent={note.noteContent}
                      effectiveDate={note.effectiveDateTime}
                      noteDate={formattedDate}
                      noteTime={formattedTime}
                      doneBy={note.doneBy}
                      timeStamp={formattedTimestamp}
                      lastModification={formattedLastModification}
                      clientPic={note.clientProfilePicture}
                      clientFirstName={note.clientFirstName}
                      clientLastName={note.clientLastName}
                      noteId={note.id}
                      fileUrls={note.fileUrls}
                      {...note}
                    />
                  );
                case "handoverNote":
                  return (
                    <HandoverNotesContainerGlobalMobile
                      key={note.id}
                      noteContent={note.noteContent}
                      effectiveDateTime={note.effectiveDateTime}
                      noteDate={formattedDate}
                      noteTime={formattedTime}
                      doneBy={note.doneBy}
                      timeStamp={formattedTimestamp}
                      lastModification={formattedLastModification}
                      noteId={note.id}
                      immmigrationAppointment={note.immmigrationAppointment}
                      dischargesSwot={note.dischargesSwot}
                      newClients={note.newClients}
                      medicalInfos={note.medicalInfos}
                      hospitalAppointment={note.hospitalAppointment}
                      residentialClientMovements={
                        note.residentialClientMovements
                      }
                      zoomSessionAssistance={note.zoomSessionAssistance}
                      updateAt={note.updateAt}
                      createdAt={note.createdAt}
                      staffToday={note.staffToday}
                      generalAnnouncement={note.generalAnnouncement}
                      {...note}
                    />
                  );

                case "groupNote":
                  return (
                    <GroupNotesContainerGlobalMobile
                      key={note.id}
                      noteContent={note.noteContent}
                      effectiveDateTime={note.effectiveDateTime}
                      noteDate={formattedDate}
                      noteTime={formattedTime}
                      doneBy={note.doneBy}
                      timeStamp={formattedTimestamp}
                      lastModification={formattedLastModification}
                      clientPic={note.clientProfilePicture}
                      clientFirstName={note.clientFirstName}
                      clientLastName={note.clientLastName}
                      noteId={note.id}
                      groupTopic={note.groupTopic}
                      groupType={note.typeGroupNote}
                      notInAttendance={note.notInAttendance}
                      updateAt={note.updateAt}
                      createdAt={note.createdAt}
                      groupStartDateTime={note.groupStartDateTime}
                      {...note}
                    />
                  );

                default:
                  return null;
              }
            })}
          </div>
          {/* <div
            style={{
              width: "20%",
              // backgroundColor: "red",
              display: "flex",
              justifyContent: "flex-start",
              alignContent: "center",
              paddingTop: "30px",
              alignItems: "center",
              flexDirection: "column",
            }}
          ></div> */}
        </div>
      </div>
      {/* <ClientsTabMobile /> */}
    </div>
  );
}
